import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import React__default, { useState, useRef, useEffect, useCallback } from 'react';
import cns from '../../node_modules/classnames/index.js';
import DropdownItem from './DropdownItem.js';
import SubMenuItem from './SubMenuItem.js';
import doesNodeContainClick from '../Utils/doesNodeContainClick.js';

function DropdownList({ children, classPrefix, right = false, onClose, }) {
    const prefix = classPrefix || 'dropdown';
    const classMenu = cns('dropdown__list', `${prefix}--menu`, right ? `${prefix}--menu--right` : '');
    return (children && (jsx("ul", { className: classMenu, role: "menu", onClick: onClose, children: children })));
}
function DropdownComponent({ open = false, disabled = false, toggleComponent = undefined, title = undefined, onClick = undefined, }) {
    return (toggleComponent
        ? React__default.cloneElement(toggleComponent, {
            disabled,
            onClick,
        })
        : (jsxs("div", { className: "dropdown__toggle", role: "presentation", onClick: disabled ? null : onClick, children: [title, jsx("span", { className: open ? 'dropdown__caret--close' : 'dropdown__caret--open' })] })));
}
const Dropdown = function Dropdown(_a) {
    var { open: openDefault = false, children = null, title = '', disabled = false, classPrefix = '', className = '', toggleComponent = undefined, right = false, onClick = undefined } = _a, others = __rest(_a, ["open", "children", "title", "disabled", "classPrefix", "className", "toggleComponent", "right", "onClick"]);
    const [open, setOpen] = useState(openDefault);
    const refNode = useRef();
    useEffect(() => {
        if (!open)
            return undefined;
        const closeIfClickOutside = (e) => {
            // console.log('closeIfClickOutside called');
            if (!doesNodeContainClick(refNode.current, e)) {
                setOpen(false);
            }
        };
        document.addEventListener('click', closeIfClickOutside);
        return () => document.removeEventListener('click', closeIfClickOutside);
    }, [open, setOpen]);
    const toggleMenu = useCallback((evt) => {
        setOpen(!open);
        if (onClick) {
            onClick(!open, evt);
        }
    }, [onClick, open]);
    const chiudi = useCallback((e) => {
        if (e.target['data-clickable'] && e.target['data-clickable'] === 'false')
            return;
        setOpen(false);
    }, [setOpen]);
    const classes = cns('dropdown', {
        'dropdown--disabled': disabled,
    }, open ? 'dropdown--open' : 'dropdown--close', classPrefix, className);
    return (jsxs("div", Object.assign({ className: classes, ref: refNode }, others, { children: [jsx(DropdownComponent, { open: open, disabled: disabled, toggleComponent: toggleComponent, title: title, onClick: toggleMenu }), open
                && (jsx(DropdownList, { classPrefix: classPrefix, right: right, onClose: chiudi, children: children }))] })));
};
Dropdown.Item = DropdownItem;
Dropdown.SubMenu = SubMenuItem;

export { Dropdown as default };
